import React, { memo } from "react";
import {
  Typography,
  Paper,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Grow,
} from "@mui/material";
import ReusableAccordian from "../ReusableAccordion";
import { RowLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useConfigSelector from "./useConfigSelector";

const StyledPaper = styled(Paper)({
  "&:hover": {
    cursor: "pointer",
  },
  marginLeft: 80,
  height: 300,
});

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
  width: 160,
}));

const StyledSelect = styled(Select)({
  backgroundColor: "white",
  width: 170,
});

const CLOUDINARY_URL = "https://res.cloudinary.com/ag-millworks/image/upload";

export const configImg = [
  {
    type: "Fixed Bi-fold",
    url: `${CLOUDINARY_URL}/v1692036783/Fixed_Panel_Configs/bifold.jpg`,
  },
  {
    type: "Fixed Slider",
    url: `${CLOUDINARY_URL}/v1692036785/Fixed_Panel_Configs/slider.jpg`,
  },
  {
    type: "Fixed Full Bound",
    url: `${CLOUDINARY_URL}/v1692036781/Fixed_Panel_Configs/fullbound.jpg`,
  },
  {
    type: "Fixed Inswing",
    url: `${CLOUDINARY_URL}/v1692377138/Fixed_Panel_Configs/inswing.jpg`,
  },
  {
    type: "Fixed Outswing",
    url: `${CLOUDINARY_URL}/v1692377136/Fixed_Panel_Configs/outswing.jpg`,
  },
  {
    type: "Direct Glaze",
    url: `${CLOUDINARY_URL}/v1726758802/Fixed_Panel_Configs/direct_glaze.jpg`,
  },
  {
    type: "Full Bound Outswing",
    url: `${CLOUDINARY_URL}/v1726677370/Fixed_Panel_Configs/fullbound_outswing_alum.jpg`,
  },
  {
    type: "Full Bound Inswing",
    url: `${CLOUDINARY_URL}/v1726677370/Fixed_Panel_Configs/fullbound_inswing_alum.jpg`,
  },
];

const FPConfigurationAccordian = () => {
  const { handleChange, exactConfig, isAluminum } = useConfigSelector();

  return (
    <ReusableAccordian
      accordionName="configuration"
      heading="Configuration"
      secondaryHeading="Select a configuration"
      required5={true}
    >
      <RowLayout>
        <Typography style={{ paddingRight: 20 }}>
          Type of Fixed Panel:
        </Typography>

        <StyledFormControl required variant="outlined">
          <InputLabel>Configuration</InputLabel>

          {isAluminum ? (
            <StyledSelect
              value={exactConfig}
              onChange={handleChange}
              name="configuration"
              label="Configuration"
              style={{ width: 200 }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value="Full Bound Outswing">
                Full Bound Outswing
              </MenuItem>
              <MenuItem value="Full Bound Inswing">
                Full Bound Inswing
              </MenuItem>
              <MenuItem value="Direct Glaze">Direct Glaze</MenuItem>
            </StyledSelect>
          ) : (
            <StyledSelect
              value={exactConfig}
              onChange={handleChange}
              name="configuration"
              label="Configuration"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value="Fixed Full Bound">Fixed Full Bound</MenuItem>
              <MenuItem value="Fixed Bi-fold">Fixed Bi-fold</MenuItem>
              <MenuItem value="Fixed Slider">Fixed Slider</MenuItem>
              <MenuItem value="Fixed Outswing">Fixed Outswing</MenuItem>
              <MenuItem value="Fixed Inswing">Fixed Inswing</MenuItem>
            </StyledSelect>
          )}
        </StyledFormControl>

        {exactConfig && (
          <Grow in={true}>
            <StyledPaper elevation={3}>
              <img
                src={configImg.find((itm) => itm.type === exactConfig)?.url}
                alt="config door"
              />
            </StyledPaper>
          </Grow>
        )}
      </RowLayout>
    </ReusableAccordian>
  );
};

export default memo(FPConfigurationAccordian);
